import script from "./dailyProductPage.vue?vue&type=script&setup=true&lang=js"
export * from "./dailyProductPage.vue?vue&type=script&setup=true&lang=js"

import "./dailyProductPage.vue?vue&type=style&index=0&id=87a3ee3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87a3ee3e"]])

export default __exports__